import { Component, ElementRef, ChangeDetectorRef, Input, Output, EventEmitter, inject, input } from '@angular/core';
import { fromEvent } from 'rxjs';
import { IconNames } from '@shared/enums/icon-names';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-info-accordion-header',
  templateUrl: './info-accordion-header.component.html',
  styleUrls: ['./info-accordion-header.component.scss'],
  imports: [NgClass, MatIcon, MatIconButton],
})
export class InfoAccordionHeaderComponent {
  private host = inject(ElementRef);
  private cdr = inject(ChangeDetectorRef);

  IconNames = IconNames;

  testId = input.required<string>();
  @Input() icon: string = IconNames.ice_circle_wave;
  @Input() displayIcon: boolean = true;
  @Input() type: 'critical' | 'neutral' = 'neutral';
  @Output() toggleInfoAccordion: EventEmitter<boolean> = new EventEmitter();

  click$ = fromEvent(this.host.nativeElement, 'click');
  rotationState = 'default';

  @Input()
  get isOpen() {
    return this._isOpen;
  }
  set isOpen(value: boolean) {
    this.rotationState = !value ? 'rotated' : 'default';
    if (this.isOpen !== value) {
      this._isOpen = value;
      this.cdr.markForCheck();
    }
  }
  private _isOpen = true;
}
